import { DefaultLogConfigService } from './logging/config/default-log-config.service';
import { InjectionToken } from '@angular/core';
import { LogConfigService } from './logging';

export class Settings {
    public logConfigService: LogConfigService = new DefaultLogConfigService();
}

export interface ModuleSettings {
    logConfigService?: LogConfigService;
}

export const FOR_ROOT_SETTINGS_TOKEN = new InjectionToken<ModuleSettings>('forRoot() Configuration Settings');

export function provideSettings(moduleSettingsFactory?: () => ModuleSettings): Settings {
    const settings = new Settings();

    if (moduleSettingsFactory) {
        const moduleSettings = moduleSettingsFactory();

        if (moduleSettings) {
            if (typeof (moduleSettings.logConfigService) === 'object') {
                settings.logConfigService = moduleSettings.logConfigService;
            }
        }
    }

    return settings;
}
